import type { Check } from './types'

import { baseAssistantOverviewUrl } from '@app/application/sf-assistant-checks/constants'

function getSfAssistantElement(): HTMLElement | null {
  return document.getElementById('sfAssistantChecksHelper')
}

export function showSfAssistantChecks(): boolean {
  return !!getSfAssistantElement()
}

interface sfAssistantChecksData {
  showElement: boolean
  parsedAccountId?: number | undefined
  parsedReconciliationId?: number | undefined
  showGeneral?: boolean
  lastMessagebusId?: number | undefined
  channel?: string
}

export function getSfAssistantChecksData(): sfAssistantChecksData {
  const sfAssistantElement = getSfAssistantElement()
  const showElement = !!sfAssistantElement
  let sfAssistantChecksData: sfAssistantChecksData = { showElement }

  if (showElement) {
    const data = sfAssistantElement.dataset

    const parsedAccountId = data.accountId
      ? parseInt(data.accountId)
      : undefined
    const parsedReconciliationId = data.reconciliationId
      ? parseInt(data.reconciliationId)
      : undefined
    const showGeneral = data.showGeneral ? data.showGeneral === 'true' : false
    const lastMessagebusId = data.lastMessagebusId
      ? parseInt(data.lastMessagebusId)
      : undefined
    const channel = data.messageBusChannel

    sfAssistantChecksData = {
      showElement,
      parsedAccountId,
      parsedReconciliationId,
      showGeneral,
      lastMessagebusId,
      channel,
    }
  }

  return sfAssistantChecksData
}

export function doneChecks(
  checks: Check[],
  remarks: Record<string, Record<string, unknown>>
): Check[] {
  if (!checks) {
    return []
  }

  return checks.filter((check) => remarks?.[check.id]?.done === true)
}

export function pendingChecks(
  checks: Check[],
  remarks: Record<string, Record<string, unknown>>
): Check[] {
  if (!checks) {
    return []
  }

  return checks.filter((check) => remarks?.[check.id]?.done === false)
}

export function sfAssistantOverviewUrl(
  objectType: string,
  objectId: number | undefined
): string {
  const params = new URLSearchParams()
  params.append('locale', window.I18n.locale)
  params.append('country', window.Silverfin.currentFirmCountry)
  params.append('firm_id', window.Silverfin.currentFirmId)
  params.append('company_id', window.Silverfin.currentCompanyId)
  params.append('period_id', window.Silverfin.currentLedgerId().toString())
  params.append('object_type', objectType)
  params.append('object_id', (objectId || '').toString())

  return `${baseAssistantOverviewUrl}${params.toString()}`
}

export function getAssistantChecksPath(
  options?: Record<string, unknown>
): string {
  const route = 'checks_ledger_assistant_checks_v2_index_path'

  return window.Silverfin.Routes[route](
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId,
    window.Silverfin.currentLedgerId(),
    options
  )
}

export function getUnreadChecksPath(workflowId?: number | null): string {
  const route = 'unread_count_ledger_assistant_checks_v2_index_path'

  return window.Silverfin.Routes[route](
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId,
    window.Silverfin.currentLedgerId(),
    {
      skip_platform_checks: true,
      ...(workflowId && { workflow_id: workflowId }),
    }
  )
}

export const UNREAD_CHECKS = 'unread'
export const ALL_CHECKS = 'all'
export const GENERAL_CHECKS = 'general'
